module.exports = __webpack_public_path__ + "static/img/V2.7182ca0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/V2.png
// module id = 67zm
// module chunks = 1